"use client";

import * as m from "motion/react-m";

interface TransitionProps {
  children: React.ReactNode;
  keyProp?: string; // Use this to differentiate between components
}

function Transition({children, keyProp}: TransitionProps) {
  return (
    <m.div
      data-slot="transition"
      key={keyProp} // Ensure React knows this is a different component during transitions
      initial={{opacity: 1, x: 0}}
      animate={{opacity: 1, x: 0}}
      exit={{opacity: 0, x: 0}}
      transition={{duration: 0.3, delay: 0.1, ease: "linear"}}
    >
      {children}
    </m.div>
  );
}

export {Transition};
